import ChatListChatsSkeleton from "./ChatListChatsSkeleton";


export const ChatListSkeleton = () => (
    <ChatListChatsSkeleton/>
)

export default ChatListSkeleton;